"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function resizeRoot() {
  var maxWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 640;
  var Dpr = 1;
  var uAgent = window.navigator.userAgent;
  var isIOS = uAgent.match(/iphone/i);
  var isYIXIN = uAgent.match(/yixin/i);
  var is2345 = uAgent.match(/Mb2345/i);
  var ishaosou = uAgent.match(/mso_app/i);
  var isSogou = uAgent.match(/sogoumobilebrowser/ig);
  var isLiebao = uAgent.match(/liebaofast/i);
  var isGnbr = uAgent.match(/GNBR/i);
  var ua = uAgent.toLowerCase();
  var wWidth = screen.width > 0 ? window.innerWidth >= screen.width || window.innerWidth == 0 ? screen.width : window.innerWidth : window.innerWidth;
  var wDpr;
  var wFsize;
  var wHeight = screen.height > 0 ? window.innerHeight >= screen.height || window.innerHeight == 0 ? screen.height : window.innerHeight : window.innerHeight;

  if (window.devicePixelRatio) {
    wDpr = window.devicePixelRatio;
  } else {
    wDpr = isIOS ? wWidth > 818 ? 3 : wWidth > 480 ? 2 : 1 : 1;
  }

  if (isIOS) {
    wWidth = screen.width;
    wHeight = screen.height;
  }

  wWidth = wWidth > maxWidth ? maxWidth : wWidth;
  wFsize = wWidth > 1080 ? 144 : wWidth / (maxWidth / 100);
  wFsize = wFsize > 32 ? wFsize : 32;
  window.screenWidth_ = wWidth;

  if (isYIXIN || is2345 || ishaosou || isSogou || isLiebao || isGnbr) {
    setTimeout(function () {
      wWidth = screen.width > 0 ? window.innerWidth >= screen.width || window.innerWidth == 0 ? screen.width : window.innerWidth : window.innerWidth;
      wHeight = screen.height > 0 ? window.innerHeight >= screen.height || window.innerHeight == 0 ? screen.height : window.innerHeight : window.innerHeight;
      wFsize = wWidth > 1080 ? 144 : wWidth / (maxWidth / 100);
      wFsize = wFsize > 32 ? wFsize : 32;
      document.querySelectorAll('html')[0].dataset.dpr = wDpr;
      document.querySelectorAll('html')[0].style.fontSize = wFsize + 'px';
    }, 500);
  } else {
    document.querySelectorAll('html')[0].dataset.dpr = wDpr;
    document.querySelectorAll('html')[0].style.fontSize = wFsize + 'px';
  }
}

function getRootSize() {
  var maxWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 640;
  var uAgent = window.navigator.userAgent;
  var isIOS = uAgent.match(/iphone/i);
  var _window = window,
      screen = _window.screen;
  var wWidth = screen.width > 0 ? window.innerWidth >= screen.width || window.innerWidth == 0 ? screen.width : window.innerWidth : window.innerWidth;
  var wFsize;

  if (isIOS) {
    wWidth = screen.width;
  }

  wWidth = wWidth > maxWidth ? maxWidth : wWidth;
  wFsize = wWidth > 1080 ? 144 : wWidth / (maxWidth / 100);
  wFsize = wFsize > 32 ? wFsize : 32;
  window.screenWidth_ = wWidth;
  wWidth = screen.width > 0 ? window.innerWidth >= screen.width || window.innerWidth == 0 ? screen.width : window.innerWidth : window.innerWidth;
  wFsize = wWidth > 1080 ? 144 : wWidth / (maxWidth / 100);
  wFsize = wFsize > 32 ? wFsize : 32;
  return wFsize;
}

var _default = {
  resizeRoot: resizeRoot,
  getRootSize: getRootSize
};
exports["default"] = _default;